import React from "react";
import assetify from "@quintype/framework/assetify";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import logo from "../../../../../assets/images/newslaundry_logo.png";
import { Link } from "@quintype/components";
import subscriptionImage from "../../../../../assets/images/nl-images/paywall-pop-up.png";
import "./request-subscription.m.css";
import { SUBSCRIPTION_PAGE_URL } from "../../../../constants";
import { connect } from "react-redux";
import get from "lodash/get";

const RequestSubscriptionBase = props => {
  const requestSubscriptionText = get(props.config, ["publisher", "publisher", "requestSubscriptionText"], "");
  const domainSlug = useSelector(state => get(state, ["qt", "domainSlug"], null));
  return !domainSlug ? (
    <div className="request-subsciption-wrapper" styleName="cta">
      <div styleName="first-content">
        <div>
          <img src={assetify(logo)} alt="subscription image"  styleName="logo"/>
          <div styleName="heading">Subscribe to read the full story</div>
        </div>
        <div styleName="get-access">
          <Link href={SUBSCRIPTION_PAGE_URL + `?ref=pw-story-url=/${props.url}`}>
            <button> Get Access </button>
          </Link>
        </div>
        <div styleName="benefits-wrapper">
          <p styleName="question">What’s included in my subscription?</p>
        </div>
        <div styleName="benefits">
          <div styleName="benefits-description">
            Access to all paywall content, including our podcasts like NL Hafta and Let’s Talk About, our video
            interviews, and comics.
          </div>
          <div styleName="benefits-description">
            Subscriber-only benefits like Zoom sessions with the NL team, and city-based private WhatsApp groups.
          </div>
          <div styleName="benefits-description">Free access to all Newslaundry events and community events.</div>
        </div>
      </div>
      <div styleName="second-content">
        <h2 styleName="question">Why should I pay for news?</h2>
        <p styleName="description">{requestSubscriptionText}</p>
        <p styleName="description">Stories cost perseverance, time and resources. </p>
      </div>
      <div styleName="info-image">
        <img src={assetify(subscriptionImage)} alt="subscription image" />
      </div>
    </div>
  ): (
    <div className="request-subsciption-wrapper" styleName="cta">
      <div styleName="first-content">
        <div>
          <img src={assetify(logo)} alt="subscription image"  styleName="logo"/>
          <div styleName="heading">पूरी ख़बर पढ़ने के लिए सब्सक्राइब करें</div>
        </div>
        <div styleName="get-access">
          <Link href={SUBSCRIPTION_PAGE_URL + `?ref=pw-story-url=/${props.url}`}>
            <button>प्रवेश का पहला चरण</button>
          </Link>
        </div>
        <div styleName="benefits-wrapper">
          <p styleName="question">मेरे सब्सक्रिप्शन में क्या-क्या शामिल है?</p>
        </div>
        <div styleName="benefits">
          <div styleName="benefits-description">
            हमारे सभी पेवॉल कंटेंट तक आपकी पहुंच होगी, जिसमें हमारे पॉडकास्ट एनएल हफ्ता, लेट्स टॉक अबाउट, हमारे वीडियो इंटरव्यूज़ और साथ में कॉमिक्स भी शामिल है.
          </div>
          <div styleName="benefits-description">
            सिर्फ सब्सक्राइबर्स को मिलने वाले फायदे: एनएल टीम के साथ जूम कॉल सेशन, अलग-अलग शहरों पर आधारित व्हाट्सएप ग्रुप की सदस्यता और साथ में न्यूज़लॉन्ड्री के इवेंट में निशुल्क प्रवेश.
          </div>
        </div>
      </div>
      <div styleName="second-content">
        <h2 styleName="question">खबरों के लिए भुगतान करना क्यों जरूरी है?</h2>
        <p styleName="description">जब तक आप इसकी बागडोर अपने हाथ में नहीं लेंगे तब तक स्वतंत्र पत्रकारिता मुमकिन नहीं है. विज्ञापन आधारित मॉडल वाली पत्रकारिता की सच्चाई आप पहले ही देख-समझ चुके हैं जहां क्लिक्स और टीआरपी की दौड़ में पत्रकारिता पीछे छूट जाती है.</p>
        <p styleName="description">खबरों को जुटाने में चुनौतियों के साथ-साथ समय और संसाधन खर्च होते हैं.</p>
      </div>
      <div styleName="info-image">
        <img src={assetify(subscriptionImage)} alt="subscription image" />
      </div>
    </div>
  )
};

RequestSubscriptionBase.propTypes = {
  config: PropTypes.object,
  url: PropTypes.string
};

const mapStateToProps = state => ({
  config: get(state, ["qt", "config"], {})
});

export const RequestSubscription = connect(mapStateToProps)(RequestSubscriptionBase);
